<div class="my-account-container page-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>
  <div class="account-container" *ngIf="user">
    <mat-tab-group dynamicHeight mat-stretch-tabs="true" (selectedTabChange)="changeMainTab($event.index)" [(selectedIndex)]="mainTab" animationDuration="100ms">
      <mat-tab label="{{sideNavComponents[0].name | translate}}" *ngIf="user.role_id !== 1">
        <mat-tab-group dynamicHeight mat-stretch-tabs="true" (selectedTabChange)="changeSecondaryTabArt($event.index)" [(selectedIndex)]="artTab" animationDuration="100ms">
          <mat-tab label="{{sideNavComponents[3].name | translate}}">
            <div *ngIf="mainTab === 0 && artTab === 0">
              <app-edit-art [loggedInUser]="user"></app-edit-art>
            </div>
          </mat-tab>
          <mat-tab label="{{sideNavComponents[4].name | translate}}">
            <div *ngIf="mainTab===0 && artTab===1">
              <app-add-art [loggedInUser]="user"></app-add-art>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-tab>
      <mat-tab  label="{{sideNavComponents[1].name | translate}}">
        <div *ngIf="(user.role_id === 2 || user.role_id === 3) && mainTab === 1 || user.role_id === 1 && mainTab===0">
          <app-my-offers [loggedInUser]="user"></app-my-offers>
        </div>
      </mat-tab>
      <mat-tab  label="{{sideNavComponents[2].name | translate}}" style="background-color: #0b5c8d !important">
        <mat-tab-group dynamicHeight mat-stretch-tabs="true" (selectedTabChange)="changeSecondaryTabAccount($event.index)" [(selectedIndex)]="accountTab" animationDuration="100ms">
          <mat-tab label="{{sideNavComponents[5].name | translate}}">
            <div *ngIf="((user.role_id === 2 || user.role_id === 3) && mainTab===2 && accountTab===0) || (user.role_id === 1 && mainTab===1 && accountTab===0)">
              <app-account-settings [loggedInUser]="user"></app-account-settings>
            </div>
          </mat-tab>
          <mat-tab label="{{sideNavComponents[6].name | translate}}" *ngIf="user.role_id === 2 || user.role_id === 3">
            <div *ngIf="mainTab===2 && accountTab==1 || mainTab===1 && accountTab===1">
              <app-subscription [loggedInUser]="user"></app-subscription>
            </div>
          </mat-tab>
          <mat-tab label="{{sideNavComponents[7].name | translate}}">
            <div *ngIf="mainTab===2 && accountTab==2 || mainTab===1 && accountTab===2">
              <app-terms-conditions></app-terms-conditions>
            </div>
          </mat-tab>
          <mat-tab label="{{sideNavComponents[8].name | translate}}"></mat-tab>
        </mat-tab-group>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
